import { useIntl } from 'react-intl';

import { renderDateString, useDateLocale } from '../../common/utils/utils';
import type { DatePickerValue } from '../../types';

import messages from './messages';

export type UseDateLabelOptions = {
	value: DatePickerValue | undefined;
	placeholder?: string;
	withTimeScale?: boolean;
	showPlaceholderWithSubtleText?: boolean;
	/** When set and value is set, shown instead of the formatted date range (e.g. interval name). */
	intervalDisplayName?: string;
};

/**
 * Shared hook for computing the date label and text color for DateRange components.
 * Used by both DateRange and ViewOnlyDateRange to maintain consistency.
 */
export const useDateLabel = ({
	value: date,
	placeholder,
	withTimeScale,
	intervalDisplayName,
}: UseDateLabelOptions): string => {
	const intl = useIntl();
	const locale = useDateLocale();

	const noDateSelectedMessage = placeholder ? placeholder : intl.formatMessage(messages.noDateSet);

	const fiscalYearPrefix =
		intervalDisplayName !== undefined ? intl.formatMessage(messages.fiscalYearPrefix) : undefined;

	const dateLabel = date
		? (renderDateString(
				locale,
				date,
				placeholder,
				withTimeScale,
				intervalDisplayName,
				fiscalYearPrefix,
			) ?? noDateSelectedMessage)
		: noDateSelectedMessage;

	return dateLabel;
};
